export default {
  header: {
    about: 'Sobre nós',
    services: 'Serviços',
    projects: 'Projetos',
    contact: 'Contato',
    impact: 'Impacto',
  },

  about: {
    eyebrow: 'Sobre a BlueAlps',
    hero_title_line1: 'Sobre',
    hero_title_line2: 'nós',
    hero_title: 'Tecnologia suíço-brasileira para empresas que querem evoluir.',
    hero_tagline:
      'Tecnologia sustentável para reduzir desigualdades e gerar impacto positivo.',
    hero_lead:
      'A BlueAlps é uma empresa suíço-brasileira especializada em desenvolvimento de software personalizado, inteligência artificial, automação e transformação digital para empresas.',
    cta_services: 'Conheça nossos serviços',
    cta_contact: 'Fale com a gente',
    story_label: 'Nossa história',
    story_title: 'Da origem suíço-brasileira a uma equipe multicultural.',
    story_title_part1: 'Uma história construída com ',
    story_title_part2: 'propósito e pessoas',
    story_paragraphs: [
      'A BlueAlps nasceu de um sonho: criar oportunidades por meio da tecnologia e gerar impacto positivo.',
      'O que começou com uma visão e o primeiro desenvolvedor cresceu e se transformou em uma equipe multicultural.',
    ],
    story_highlight:
      'Hoje, <strong>empresas</strong> confiam no nosso potencial para construir soluções inovadoras e sustentáveis.',
    story_stat_countries: '<strong>2 países</strong> conectados',
    story_stat_solutions: '<strong>Soluções</strong> personalizadas',
    client_map_title: 'Nossos principais clientes',
    client_map_country: 'Suíça',
    story_quote:
      'Nosso principal diferencial é entregar <strong>qualidade suíça</strong> com <strong>um dos menores valores do mercado</strong>. Unimos criatividade brasileira, precisão suíça e uma operação eficiente para oferecer soluções de alto desempenho com preço mais acessível.',
    story_steps: [
      {
        title: 'O sonho',
        text: 'Tecnologia para criar oportunidades e impacto positivo.',
      },
      {
        title: 'O primeiro passo',
        text: 'Uma visão ganhou vida com o primeiro desenvolvedor.',
      },
      {
        title: 'A equipe cresceu',
        text: 'Novos talentos e perspectivas se uniram à jornada.',
      },
      {
        title: 'A confiança chegou',
        text: 'Mais de 5 empresas passaram a confiar em nós.',
      },
      {
        title: 'Estamos apenas começando',
        text: 'Seguimos crescendo entre Brasil e Suíça.',
      },
    ],
    faq: {
      label: 'FAQ',
      title: 'Perguntas frequentes',
      subtitle:
        'Respostas diretas sobre como trabalhamos, nossos diferenciais e o que entregamos em cada projeto.',
      items: [
        {
          question: 'Qual é o principal diferencial da BlueAlps?',
          answer:
            'Unimos qualidade suíça, criatividade brasileira e uma operação eficiente para entregar tecnologia de alto desempenho com um dos menores valores do mercado.',
        },
        {
          question: 'A BlueAlps atende empresas fora da Suíça?',
          answer:
            'Sim. Atuamos com empresas na Suíça, no Brasil e em outros mercados, com comunicação remota, processos claros e entregas estruturadas.',
        },
        {
          question: 'Que tipo de solução vocês desenvolvem?',
          answer:
            'Desenvolvemos software personalizado, automações, soluções com inteligência artificial, integrações, sites, sistemas internos e projetos de transformação digital.',
        },
        {
          question: 'Como funciona o início de um projeto?',
          answer:
            'Começamos entendendo o objetivo, o cenário atual e as prioridades do cliente. Depois propomos escopo, etapas, prazo e investimento de forma transparente.',
        },
      ],
    },
    feedback: {
      label: 'Feedback de clientes',
      title: 'O que nossos clientes dizem',
      subtitle:
        'Parcerias construídas com clareza, responsabilidade e foco em resultados digitais consistentes.',
      items: [
        {
          quote:
            'Estamos muito satisfeitos com a colaboração. A equipe jovem e motivada trabalha de forma simples, orientada a soluções e com muito comprometimento. Nossas demandas sempre foram levadas a sério e implementadas rapidamente - exatamente como se espera de uma parceria de sucesso.',
          name: 'Cornelia',
          company: 'Divina Textil AG',
          companyUrl: 'https://www.divina.ch/de',
        },
        {
          quote:
            'A colaboração foi muito agradável. Quando conheci a Laryssa, fiquei muito tranquila, pois a comunicação em alemão se tornou muito mais fácil e pessoal. Valorizei especialmente as respostas rápidas, a paciência e o suporte da equipe, mesmo depois que a homepage já estava online.',
          name: 'Erika',
          company: 'Projeto Müller',
          companyUrl: 'https://mueller-handarbeiten.ch/',
        },
        {
          quote:
            'A colaboração com Igor no desenvolvimento contínuo de HausHeld.ch, Aufzugo e outros projetos sempre foi muito profissional e confiável. Valorizamos especialmente sua alta qualidade, sua rápida implementação de feedbacks e sua forma de trabalhar orientada a soluções. Igor é um parceiro valorizado, que podemos recomendar a qualquer momento.',
          name: 'Alessandro Affentranger',
          company: 'Head de Desenvolvimento - Vermando AG',
          companyUrl: 'https://www.vermando.com/',
        },
      ],
    },
    website_carousel: {
      label: 'Nosso site',
      title: 'Conheça o que você encontra na BlueAlps',
      subtitle:
        'Cada área do site foi pensada para apresentar como unimos tecnologia, impacto e parceria.',
      items: [
        {
          title: 'Serviços',
          description:
            'Explore nossas soluções em software, inteligência artificial, automação, SEO técnico, UX, PIM, WordPress e cibersegurança.',
        },
        {
          title: 'Impacto',
          description:
            'Entenda como conectamos tecnologia e responsabilidade social para gerar resultados alinhados a um futuro mais sustentável.',
        },
        {
          title: 'Projetos',
          description:
            'Veja exemplos de entregas digitais, cases e iniciativas que mostram nossa capacidade técnica na prática.',
        },
        {
          title: 'Contato',
          description:
            'Fale com a equipe BlueAlps para apresentar seu desafio, pedir uma proposta ou iniciar uma nova parceria.',
        },
        {
          title: 'Valores',
          description:
            'Conheça os princípios que orientam nossas decisões, nossa cultura e a forma como construímos relações de confiança.',
        },
      ],
    },
    team: {
      label: 'Time BlueAlps',
      title: 'As pessoas por trás da tecnologia',
      subtitle:
        'Um grupo multicultural que une estratégia, engenharia e execução para transformar ideias em soluções digitais.',
      linkedin_label: 'Ver LinkedIn de {{name}}',
      members: [
        {
          name: 'Daniel Hefti',
          role: 'Chief Executive Officer',
          description:
            'Lidera a visão estratégica da BlueAlps, conectando o mercado suíço a soluções digitais com impacto e qualidade.',
        },
        {
          name: 'Igor Araújo',
          role: 'IT Manager & Full-Stack Developer',
          description:
            'Ajuda empresas a criar funcionalidades sob medida, melhorar SEO técnico, integrar APIs e reforçar a cibersegurança de sites e plataformas digitais.',
        },
        {
          name: 'Maria Victória',
          role: 'IT Manager & Frontend Developer',
          description:
            'Une gestão de TI, e-commerce, UX, ferramentas Google e criação de design para transformar ideias em experiências digitais claras e funcionais.',
        },
        {
          name: 'Matheus Luiz',
          role: 'Backend Developer & DevOps',
          description:
            'Foca em backend, IA, automações e integrações para e-commerce e PIM Core, criando fluxos inteligentes para dados, produtos e operações.',
        },
        {
          name: 'Laryssa Sams',
          role: 'Customer Relations',
          description:
            'Apoia a comunicação com clientes e parceiros, garantindo clareza, acompanhamento e cuidado em cada etapa.',
        },
      ],
    },
    mission_title: 'Missão',
    mission_text:
      'Apoiar empresas com soluções de software acessíveis, performáticas e orientadas a impacto, conectando conhecimento técnico, entendimento de negócio e responsabilidade social.',
    vision_title: 'Visão',
    vision_text:
      'Promover um futuro mais justo, inclusivo e sustentável por meio de tecnologia bem construída, colaboração internacional e inovação aplicada a desafios reais.',
    values_label: 'Nossos valores',
    values_title: 'Nossos valores',
    values_intro:
      'Nossos valores são a base da nossa identidade e guiam todas as nossas decisões. Eles moldam nossa cultura, nossas parcerias e o impacto que queremos gerar.',
    values: {
      equity: {
        title: 'Equidade',
        text: 'Promovemos oportunidades e resultados justos para todas as pessoas, com justiça em parcerias, processos e no ambiente de trabalho.',
      },
      inclusion: {
        title: 'Inclusão & Diversidade',
        text: 'Criamos ambientes acolhedores, valorizando diferentes vozes, origens, culturas e experiências.',
      },
      integrity: {
        title: 'Integridade',
        text: 'Atuamos com transparência, ética e responsabilidade em todas as interações com clientes, colegas e comunidade.',
      },
      collaboration: {
        title: 'Colaboração',
        text: 'Acreditamos no crescimento por meio da cooperação, de parcerias fortes e de objetivos construídos com respeito.',
      },
      sustainability: {
        title: 'Sustentabilidade',
        text: 'Tomamos decisões que promovem saúde ambiental, social e econômica, pensando no presente e no futuro.',
      },
    },
    final_cta: {
      title_line1: 'Vamos construir',
      title_line2: 'algo gigante',
      title_accent: 'juntos?',
      contact_button: 'Fale conosco',
    },
  },

  impact: {
    hero: {
      title_line1: 'Impacto que conecta engenharia,',
      title_line2: 'sustentabilidade e resultados reais.',
      subtitle:
        'Na BlueAlps, transformamos visão em impacto mensurável por meio de soluções ágeis, acessíveis e guiadas por propósito — em alinhamento com os Objetivos de Desenvolvimento Sustentável da ONU.',
      description:
        'Na BlueAlps, acreditamos que a tecnologia pode gerar impacto positivo. Por isso, alinhamos nossas estratégias aos ODS da ONU. Trabalhamos por um futuro sustentável, justo e cheio de oportunidades para todas as pessoas. Junte-se a nós nessa jornada e descubra como nossas soluções de software podem fortalecer o seu negócio enquanto geram impacto duradouro.',
      cta_primary: 'Ver nossos projetos',
      cta_secondary: 'Ver nossos serviços',
    },

    ods: {
      title: 'Impacto alinhado aos Objetivos de Desenvolvimento Sustentável',
      subtitle:
        'Nossas soluções são pensadas para entregar resultados concretos e, ao mesmo tempo, contribuir diretamente com os ODS da ONU — com tecnologia, responsabilidade e impacto mensurável.',
      items: {
        ods3: {
          title: 'ODS 3 — Saúde e Bem-Estar',
          desc: 'Projetos que promovem saúde, segurança e qualidade de vida, apoiando sistemas seguros, confiáveis e acessíveis.',
        },

        ods8: {
          title: 'ODS 8 — Trabalho Decente e Crescimento Econômico',
          desc: 'Soluções de engenharia que aumentam eficiência, reduzem desperdício e devolvem tempo para o time focar no que gera valor.',
        },

        ods9: {
          title: 'ODS 9 — Indústria, Inovação e Infraestrutura',
          desc: 'Arquiteturas modernas, escaláveis e resilientes para apoiar o crescimento de PMEs guiadas por propósito — sem compromissos técnicos.',
        },

        ods12: {
          title: 'ODS 12 — Consumo e Produção Responsáveis',
          desc: 'Redução de desperdício digital, uso otimizado de recursos e decisões orientadas por dados para tecnologias mais sustentáveis.',
        },

        ods13: {
          title: 'ODS 13 — Ação Climática',
          desc: 'Projetos com foco em eficiência energética, monitoramento e redução da pegada de CO2 de soluções digitais.',
        },
      },
    },

    how: {
      title: 'Impacto feito por pessoas — e provado na prática.',
      subtitle:
        'Nada de “impacto de marketing”. Cada entrega nasce de trabalho real em projeto — com eficiência, responsabilidade e acessibilidade.',
      badge: 'Time em ação 🚀',
    },

    steps: {
      step1: {
        title: 'Do problema real a um plano que funciona',
        desc: 'Analisamos o contexto, definimos métricas e priorizamos ações com o maior impacto.',
      },

      step2: {
        title: 'Entrega enxuta com alta qualidade',
        desc: 'Performance, Developer Experience e manutenibilidade em foco — escalável e sustentável.',
      },

      step3: {
        title: 'Medição, não achismo',
        desc: 'Monitoramos KPIs e validamos resultados: custos, energia, confiabilidade, acessibilidade e experiência do usuário.',
      },

      step4: {
        title: 'Parceria contínua',
        desc: 'Impacto sustentável nasce de colaboração de longo prazo e melhoria contínua.',
      },
    },

    teamImpact: {
      title: 'Projetos do nosso time com impacto real',
      subtitle:
        'Cada card mostra o que foi entregue, por quem — e qual impacto isso gerou.',
    },

    projects: {
      impactLabel: 'Impacto gerado',

      items: {
        p1: {
          author: 'Maria — Frontend & QA',
          role: 'Plataforma & UX de Dados (Mama Ativa)',
          title:
            'Mama Ativa: mais doações com gamificação + previsões de escassez orientadas por dados',
          summary:
            'Plataforma para incentivar doações de leite materno com incentivos gamificados e analytics, ajudando doadoras a ver onde a demanda cresce — e equipes a identificar escassez com antecedência.',
          impact:
            'Resultado: melhor distribuição das doações, resposta mais rápida a risco de falta e mais transparência para doadoras e gestão.',
          ods: 'ODS 3 — ODS 9 — ODS 12',
          tags: 'Data Analytics — Gamificação — HealthTech',
        },

        p2: {
          author: 'Maria & Matheus — App & Backend',
          role: 'App de Segurança (Alerta Rosa)',
          title:
            'Alerta Rosa: acesso mais rápido à ajuda e rotas mais seguras no dia a dia',
          summary:
            'App de segurança com alarme SOS, contatos de emergência rápidos e informações de localização/serviços para tornar o suporte imediato em situações críticas.',
          impact:
            'Resultado: menor tempo de resposta, caminho claro de ação no emergencial e mais segurança no cotidiano — especialmente em momentos de estresse.',
          ods: 'ODS 5 — ODS 11 — ODS 16',
          tags: 'Segurança da Mulher — SOS — App Mobile',
        },
      },
    },

    cta: {
      title: 'Bora criar projetos sustentáveis com impacto mensurável?',
      desc: 'Conte o seu desafio. A gente entrega com excelência e comprova impacto com dados.',
      button: 'Falar com a BlueAlps',
    },
  },

  services: {
    hero_title: 'Especialistas em engenharia digital com impacto real',
    hero_subtitle:
      'Disponibilizamos especialistas sob demanda para fortalecer sua organização — de SEO técnico e PIM a WordPress e cibersegurança, com foco em resultados mensuráveis.',
    direct_contact_note: 'Entramos em contato do Brasil diretamente com você.',
    currency_selector_kicker: 'Moeda dos valores',
    currency_selector_title: 'Escolha a moeda exibida nos preços',
    currency_selector_subtitle:
      'Os cards e a tabela comercial abaixo são recalculados automaticamente com a moeda selecionada.',
    currency_selector_aria_label: 'Selecionar moeda dos preços',
    currency_selector_options: {
      CHF: 'Franco suíço',
      USD: 'Dólar americano',
      EUR: 'Euro',
    },
    cta_request_specialist: 'Solicitar especialistas',
    view_details: 'Ver detalhes',
    back_to_services: 'Voltar para serviços',
    detail_what_is_title: 'O que é o serviço?',
    detail_deliverables_title: 'O que está incluso',
    detail_value_title: 'Valor',
    detail_discount_note:
      'Projetos com maior custo podem receber descontos progressivos conforme escopo, duração e volume contratado.',
    detail_schedule_cta: 'Agendar',
    detail_booking_strip_label: 'Reunião gratuita',
    detail_booking_strip_title: 'Converse com a BlueAlps antes de decidir.',
    detail_booking_strip_text:
      'Em poucos minutos alinhamos seu objetivo, tiramos dúvidas e mostramos o caminho mais simples para começar.',
    detail_booking_reasons_label: 'Próximo passo',
    detail_booking_reasons_title: 'Por que vale agendar uma conversa agora?',
    detail_booking_reasons_text:
      'A reunião ajuda a transformar interesse em um plano claro, com prioridades, escopo e próximos passos.',
    detail_booking_reason_1_title: 'Diagnóstico rápido',
    detail_booking_reason_1_text:
      'Entendemos o cenário atual e identificamos onde este serviço pode gerar impacto mais rápido.',
    detail_booking_reason_2_title: 'Escopo sem ruído',
    detail_booking_reason_2_text:
      'Você sai com mais clareza sobre entregas, esforço necessário e melhor formato de contratação.',
    detail_booking_reason_3_title: 'Sem compromisso',
    detail_booking_reason_3_text:
      'A conversa é gratuita e serve para avaliar se faz sentido avançar com a BlueAlps.',
    detail_final_cta_label: 'Pronto para avançar?',
    detail_final_cta_title: 'Agende uma reunião e tire seu projeto do papel.',
    detail_final_cta_text:
      'Escolha um horário no Microsoft Bookings e fale diretamente com nosso time sobre este serviço.',
    detail_ideal_client_title: 'Para quem é este serviço?',

    plan_price_from: 'Por hora',
    plan_recommended_fast_impact: 'Impacto rápido',
    plan_recommended_specialty: 'Nossa especialidade',

    plan_ecommerce_title: 'E-commerce',
    plan_ecommerce_desc:
      'Criação, reconstrução e evolução de lojas online com catálogo claro, checkout confiável, integrações e base preparada para crescer.',

    plan_ux_title: 'Otimização de Layout & UX',
    plan_ux_desc:
      'Melhoria de hierarquia visual, usabilidade e conversão com ajustes direcionados de layout e recomendações de UX.',

    plan_tech_seo_title: 'Especialistas em SEO Técnico',
    plan_tech_seo_desc:
      'Melhore crawl, velocidade e indexação com SEO técnico que se traduz em crescimento mensurável.',

    plan_analytics_schema_title: 'Google Analytics & Schema',
    plan_analytics_schema_desc:
      'Configuração de mensuração, eventos, conversões e dados estruturados para entender resultados e melhorar presença nos buscadores.',

    plan_pim_title: 'Especialistas em PIM (Open Source)',
    plan_pim_note: ' Gestão de Informação de Produto',
    plan_pim_desc:
      'Construção ou integração de um PIM open source para centralizar dados de produto e elevar a qualidade das informações.',

    plan_wordpress_title: 'Especialistas em WordPress',
    plan_wordpress_desc:
      'Desenvolvimento WordPress confiável, com performance, segurança e manutenibilidade desde o dia 1.',

    plan_cyber_title: 'Especialistas em Cibersegurança',
    plan_cyber_desc:
      'Fortaleça sua postura de segurança com hardening prático, monitoramento e prontidão para incidentes.',

    plan_digital_link_page_title: 'Digitale Linkseite',
    plan_digital_link_page_desc:
      'Páginas de links digitais personalizadas para reunir links importantes, redes sociais, contatos e ofertas em um só lugar.',

    plan_individual_title: 'Individual',
    plan_business_title: 'Business',
    plan_business_recommended: 'Recomendado',
    plan_custom_title: 'Custom (Sob demanda)',
    plan_audit_title: 'Auditoria',

    plan_individual_desc:
      'Ideal para pessoas e pequenos negócios que precisam de uma presença online simples e eficiente.',
    plan_business_desc:
      'Para empresas em crescimento que precisam de mais páginas, integrações e conteúdo dinâmico.',
    plan_design_note: 'Design responsivo e prototipação.',
    plan_custom_desc:
      'Projetos sob medida e escaláveis — totalmente adaptados às suas necessidades.',
    plan_audit_feature_privacy: 'Relatório de privacidade e conformidade',
    plan_audit_feature_performance: 'Análise de performance e SEO',
    plan_audit_feature_accessibility: 'Revisão de acessibilidade e usabilidade',
    plan_audit_feature_security: 'Checklist de segurança e riscos',
    plan_audit_desc:
      'Auditoria completa de privacidade, performance e impacto ambiental — com recomendações claras e acionáveis.',

    ideal_clients: {
      ecommerce:
        'Para empresas que querem vender online com uma loja confiável, fácil de administrar e preparada para integrar produtos, pagamentos, logística e marketing.',
      tech_seo:
        'Para empresas que já têm site, e-commerce ou plataforma digital e precisam melhorar a visibilidade nos buscadores, velocidade, indexação e qualidade técnica do tráfego orgânico.',
      analytics_schema:
        'Para empresas que precisam medir melhor visitas, eventos e conversões, além de estruturar dados para que buscadores entendam páginas, produtos, serviços e conteúdos.',
      pim: 'Para empresas com muitos produtos, dados espalhados em planilhas, ERP ou e-commerce, e times que precisam organizar informações de produto com mais qualidade e automação.',
      wordpress:
        'Este serviço é ideal para empresas e profissionais que precisam de um site WordPress profissional, rápido, seguro e fácil de administrar. Seja para criar um novo site do zero, modernizar uma estrutura existente, melhorar a performance de um site lento ou garantir manutenção contínua, o serviço atende quem busca uma solução confiável e preparada para acompanhar o crescimento do negócio.',
      ux: 'Para empresas que percebem baixa conversão, navegação confusa, layout desatualizado ou dificuldade dos usuários para encontrar e concluir ações importantes.',
      digital_link_page:
        'Para profissionais, marcas e negócios que precisam de uma página simples, bonita e organizada para concentrar links, redes sociais, contatos e ofertas.',
      cyber:
        'Para organizações que lidam com dados sensíveis, acessos internos, sistemas online ou sites críticos e precisam reduzir riscos de segurança de forma prática.',
      audit:
        'Para empresas que querem entender rapidamente os principais problemas de privacidade, performance, SEO, acessibilidade e segurança antes de investir em melhorias.',
    },

    detail_outcomes_title: 'Resultados esperados',
    detail_when_to_use_title: 'Quando contratar',
    detail_workflow_title: 'Como trabalhamos',
    detail_timeline_period: 'Etapa {{count}}',
    detail_timeline_keyword: 'FASE PRINCIPAL',
    detail_faq_title: 'Perguntas frequentes sobre este serviço',
    service_details: {
      ecommerce: {
        overview:
          'O serviço de E-commerce cria, reconstrói ou evolui lojas online com foco em catálogo bem organizado, checkout confiável, integrações essenciais e operação preparada para crescer.',
        outcomes: [
          'Loja online mais clara, profissional e fácil de administrar.',
          'Catálogo, páginas de produto e jornada de compra mais bem estruturados.',
          'Integrações com pagamentos, logística, ERP, PIM ou ferramentas de marketing.',
          'Base técnica preparada para performance, SEO, mensuração e evolução contínua.',
        ],
        when_to_use: [
          'Você quer lançar uma loja online nova.',
          'Sua loja atual é difícil de manter, lenta ou pouco confiável.',
          'Catálogo, checkout ou integrações estão limitando o crescimento.',
          'Você precisa conectar e-commerce com dados de produto, ERP ou campanhas.',
        ],
        workflow: [
          'Entendemos catálogo, jornada de compra, integrações e regras comerciais.',
          'Planejamos arquitetura, plataforma, páginas, dados e fluxos de checkout.',
          'Implementamos a loja com foco em performance, usabilidade e gestão simples.',
          'Testamos compra, pagamentos, integrações e entregamos documentação para operação.',
        ],
        workflow_titles: [
          'Entendemos',
          'Planejamos',
          'Construímos',
          'Entregamos',
        ],
        faq: [
          {
            question: 'Vocês criam lojas do zero?',
            answer:
              'Sim. Podemos criar uma loja nova ou reconstruir uma loja existente, definindo plataforma, estrutura, catálogo, checkout e integrações de acordo com o escopo.',
          },
          {
            question: 'Vocês integram com ERP, PIM ou meios de pagamento?',
            answer:
              'Sim. Avaliamos as integrações necessárias e priorizamos as conexões que reduzem trabalho manual e melhoram a operação.',
          },
          {
            question: 'Quando faz sentido usar PIM junto com o e-commerce?',
            answer:
              'Faz sentido quando a loja tem muitos produtos, variações, idiomas, canais de venda ou retrabalho com dados. O PIM centraliza as informações e alimenta o e-commerce com dados mais consistentes.',
          },
          {
            question: 'A loja fica preparada para SEO e analytics?',
            answer:
              'Sim. Organizamos estrutura, páginas, eventos e bases técnicas para facilitar mensuração, indexação e evolução.',
          },
          {
            question: 'Qual plataforma vocês usam para e-commerce?',
            answer:
              'Depende do projeto. Avaliamos catálogo, integrações, orçamento, autonomia do time e planos de crescimento antes de recomendar a plataforma mais adequada.',
          },
          {
            question: 'Vocês cadastram produtos?',
            answer:
              'Podemos apoiar no cadastro inicial, estruturação de categorias, atributos, variações e imagens. Para catálogos maiores, recomendamos organizar os dados com PIM ou planilhas bem estruturadas.',
          },
          {
            question: 'Vocês migram uma loja existente?',
            answer:
              'Sim. Primeiro analisamos plataforma atual, produtos, URLs, integrações, pedidos, clientes e riscos de SEO para definir uma migração com o menor impacto possível.',
          },
          {
            question: 'A loja pode ter meios de pagamento e frete?',
            answer:
              'Sim. Podemos integrar meios de pagamento, regras de frete, cálculo de entrega e soluções logísticas conforme disponibilidade técnica da plataforma e dos provedores.',
          },
          {
            question: 'Vocês melhoram uma loja que já está no ar?',
            answer:
              'Sim. Podemos otimizar performance, páginas de produto, checkout, eventos de analytics, SEO técnico, integrações e pontos de fricção na jornada de compra.',
          },
          {
            question: 'Depois da entrega eu consigo administrar a loja?',
            answer:
              'Sim. Estruturamos a loja para facilitar a gestão diária e entregamos orientação ou documentação para que sua equipe consiga atualizar produtos, conteúdo e configurações básicas.',
          },
          {
            question: 'Quanto tempo leva um projeto de e-commerce?',
            answer:
              'O prazo depende de escopo, número de páginas, volume de produtos, integrações e necessidade de migração. Após a análise inicial, definimos um cronograma realista por etapas.',
          },
        ],
      },
      tech_seo: {
        overview:
          'O serviço de SEO Técnico analisa e melhora a base técnica do seu site para que mecanismos de busca consigam rastrear, entender e indexar melhor suas páginas. O trabalho conecta performance, estrutura, mensuração e priorização para transformar problemas técnicos em ações claras de crescimento.',
        outcomes: [
          'Mais clareza sobre gargalos que impedem páginas importantes de ranquear.',
          'Melhor desempenho em velocidade, Core Web Vitals e experiência mobile.',
          'Arquitetura técnica mais fácil de ser lida por buscadores e ferramentas de analytics.',
          'Plano de ação priorizado por impacto, esforço e risco para o negócio.',
        ],
        when_to_use: [
          'Seu site tem tráfego orgânico baixo ou instável.',
          'Páginas importantes não aparecem bem nos buscadores.',
          'O site está lento, pesado ou com problemas em mobile.',
        ],
        workflow: [
          'Diagnóstico técnico de rastreamento, indexação, velocidade e estrutura.',
          'Priorização dos problemas com maior impacto em visibilidade e conversão.',
          'Implementação ou orientação técnica junto ao seu time.',
          'Relatório mensal ou quinzenal com acompanhamento das principais métricas e evolução dos resultados.',
        ],
        workflow_titles: [
          'Diagnóstico técnico',
          'Priorização',
          'Implementação',
          'Acompanhamento',
        ],
        faq: [
          {
            question: 'Em quanto tempo o SEO técnico começa a gerar resultado?',
            answer:
              'Correções de performance e indexação podem mostrar sinais em poucas semanas, mas ganhos de ranking dependem de histórico do domínio, concorrência, conteúdo e frequência de rastreamento do Google.',
          },
          {
            question:
              'Vocês implementam as correções ou só entregam relatório?',
            answer:
              'Podemos fazer as duas coisas: entregar um plano técnico para o seu time ou apoiar diretamente na implementação, validação e acompanhamento das mudanças.',
          },
          {
            question: 'SEO técnico substitui conteúdo ou anúncios?',
            answer:
              'Não. Ele fortalece a base para conteúdo e campanhas performarem melhor. Em muitos casos, corrigir problemas técnicos aumenta o retorno do conteúdo já existente.',
          },
        ],
      },
      analytics_schema: {
        overview:
          'O serviço de Google Analytics & Schema organiza a mensuração do site e implementa dados estruturados para que sua equipe acompanhe resultados com mais clareza e os buscadores entendam melhor suas páginas.',
        outcomes: [
          'Google Analytics configurado com eventos e conversões relevantes.',
          'Google Tag Manager organizado para facilitar manutenção futura.',
          'Eventos de Google Shopping preparados para acompanhar interações comerciais importantes.',
          'Schema markup aplicado em páginas, serviços, produtos ou conteúdos importantes.',
          'Validação técnica para reduzir erros de mensuração e dados estruturados.',
        ],
        when_to_use: [
          'Você não confia nos dados atuais de tráfego e conversão.',
          'Eventos importantes não estão sendo medidos corretamente.',
          'Você quer melhorar a leitura do site por ferramentas de busca.',
          'Campanhas e decisões precisam de dados mais confiáveis.',
        ],
        workflow: [
          'Mapeamos objetivos, eventos, conversões e páginas prioritárias.',
          'Configuramos tags, eventos, parâmetros e dados estruturados necessários.',
          'Validamos coleta, disparos, relatórios e marcações schema.',
          'Documentamos a configuração para manutenção e evolução.',
        ],
        workflow_titles: ['Mapeamento', 'Configuração', 'Validação', 'Entrega'],
        faq: [
          {
            question: 'Vocês configuram GA4 e Google Tag Manager?',
            answer:
              'Sim. Podemos configurar GA4, GTM, eventos, conversões, parâmetros e eventos de Google Shopping conforme os objetivos do site.',
          },
          {
            question: 'Schema ajuda em SEO?',
            answer:
              'Ajuda a estruturar informações para buscadores. Ele não garante posições, mas melhora a clareza técnica sobre páginas, produtos, serviços e conteúdos.',
          },
          {
            question: 'Vocês corrigem dados de analytics inconsistentes?',
            answer:
              'Sim. Revisamos a implementação atual, encontramos duplicidades ou lacunas e reorganizamos a coleta.',
          },
        ],
      },
      pim: {
        overview:
          'O serviço de PIM organiza informações de produto em uma base central confiável, reduzindo retrabalho entre e-commerce, ERP, catálogos, marketplaces e times internos. A solução melhora qualidade dos dados, consistência comercial e velocidade de publicação.',
        outcomes: [
          'Dados de produto centralizados, padronizados e mais fáceis de manter.',
          'Menos erros em descrições, atributos, categorias, imagens e traduções.',
          'Integrações mais estáveis entre sistemas comerciais e canais digitais.',
          'Processos de importação, validação e exportação mais rápidos.',
        ],
        when_to_use: [
          'Produtos são gerenciados em muitas planilhas ou sistemas diferentes.',
          'Seu time perde tempo corrigindo informações repetidas.',
          'Você vende em múltiplos canais e precisa de consistência.',
          'O crescimento do catálogo está dificultando a operação.',
        ],
        workflow: [
          'Mapeamento dos dados atuais, sistemas conectados e regras de negócio.',
          'Modelagem de atributos, categorias, validações e fluxos de atualização.',
          'Integração com ERP, e-commerce, APIs ou arquivos de importação.',
          'Treinamento e documentação para o time operar com autonomia.',
        ],
        workflow_titles: [
          'Mapeamento',
          'Modelagem',
          'Integração',
          'Treinamento',
        ],
        faq: [
          {
            question: 'Preciso trocar meu ERP ou e-commerce para usar um PIM?',
            answer:
              'Normalmente não. O PIM entra como uma camada central de dados e pode se integrar ao ERP, e-commerce, marketplaces ou arquivos que sua operação já usa.',
          },
          {
            question: 'Como o PIM ajuda uma operação de e-commerce?',
            answer:
              'Ele centraliza descrições, atributos, imagens, categorias e traduções para que a loja receba dados mais completos e consistentes, reduzindo erros e acelerando publicações.',
          },
          {
            question: 'O PIM serve para catálogos pequenos?',
            answer:
              'Pode servir, mas o maior retorno aparece quando há muitos SKUs, variações, idiomas, canais de venda ou retrabalho recorrente com dados de produto.',
          },
          {
            question: 'O time recebe treinamento?',
            answer:
              'Sim. A entrega inclui documentação e orientação para que produto, marketing e tecnologia saibam manter os dados com qualidade.',
          },
        ],
      },
      wordpress: {
        overview:
          'O serviço de WordPress cobre criação, reconstrução, otimização e manutenção técnica de sites em WordPress. O foco é entregar uma base estável, segura, rápida e simples de administrar, evitando excesso de plugins e decisões difíceis de manter.',
        outcomes: [
          'Mais velocidade: menos tempo de carregamento e uma experiência melhor para quem acessa o site.',
          'Menos complexidade: plugins, tema e configurações revisados para evitar dependências desnecessárias.',
          'Mais segurança: uma instalação protegida e com uma rotina mais confiável de atualizações e backups.',
          'Mais autonomia: uma estrutura organizada para que sua equipe consiga administrar o conteúdo sem depender de um desenvolvedor para cada alteração.',
          'Mais previsibilidade: um WordPress preparado para manutenção, evolução e novas funcionalidades.',
        ],
        when_to_use: [
          'Um site novo: você precisa criar ou reconstruir um site institucional com uma estrutura profissional, fácil de administrar e preparada para crescer.',
          'Um site que está lento: seu WordPress demora para carregar, apresenta problemas de performance ou acumulou plugins, scripts e configurações ao longo do tempo.',
          'Um site que precisa de cuidado: você quer manter seu site atualizado, seguro e estável sem precisar transformar sua equipe em especialistas em WordPress.',
        ],
        workflow: [
          'Analisamos o site, seus objetivos, conteúdo, estrutura atual e principais problemas.',
          'Definimos a arquitetura, ferramentas e soluções necessárias para o projeto.',
          'Implementamos o site com foco em performance, segurança, usabilidade e facilidade de manutenção.',
          'Publicamos, testamos e documentamos o projeto para que sua equipe saiba como administrar o site.',
        ],
        workflow_titles: [
          'Entendemos',
          'Planejamos',
          'Construímos',
          'Entregamos',
        ],
        faq: [
          {
            question: 'Vocês trabalham com sites WordPress já existentes?',
            answer:
              'Sim. Podemos assumir sites construídos por outras equipes ou agências para manutenção, otimização ou reconstrução. Antes de alterar qualquer coisa, fazemos uma análise técnica para identificar problemas de estrutura, plugins, performance e segurança.',
          },
          {
            question: 'É possível reduzir plugins sem perder funcionalidades?',
            answer:
              'Na maioria dos casos, sim. Analisamos quais plugins são realmente necessários, quais podem ser substituídos por recursos nativos ou soluções mais simples e quais estão causando conflitos ou sobrecarga.',
          },
          {
            question: 'WordPress é seguro?',
            answer:
              'Sim, desde que seja corretamente configurado e mantido. Trabalhamos com atualizações, controle de permissões, hardening, backups e outras medidas para reduzir os principais riscos de uma instalação WordPress.',
          },
          {
            question:
              'Meu site está lento. Vocês conseguem descobrir o problema?',
            answer:
              'Sim. Analisamos a instalação, hospedagem, banco de dados, imagens, cache, plugins e scripts para identificar os principais gargalos e priorizar as otimizações que realmente fazem diferença.',
          },
          {
            question: 'Vocês trabalham com Elementor?',
            answer:
              'Sim. Podemos trabalhar com sites existentes em Elementor e também desenvolver novos projetos utilizando o construtor quando ele fizer sentido para o projeto.',
          },
          {
            question: 'Vocês fazem manutenção depois da entrega?',
            answer:
              'Sim. O projeto pode ser entregue para sua equipe administrar ou continuar conosco através de um plano de manutenção.',
          },
          {
            question:
              'Vocês conseguem reconstruir um site sem começar tudo do zero?',
            answer:
              'Sim. Primeiro avaliamos o que pode ser aproveitado e o que está causando problemas. Em muitos casos, reconstruir apenas a estrutura necessária é mais eficiente do que substituir o site inteiro.',
          },
          {
            question: 'Quanto custa um projeto em WordPress?',
            answer:
              'O valor depende do escopo, número de páginas, integrações, nível de personalização e estado atual do site. Para projetos maiores, fazemos uma análise inicial e apresentamos uma proposta de acordo com o escopo definido.',
          },
          {
            question: 'Por que usar WordPress?',
            answer:
              'WordPress oferece uma combinação de flexibilidade, autonomia e possibilidade de evolução que funciona bem para muitos sites institucionais e projetos digitais.\n\nMas não recomendamos WordPress simplesmente por ser WordPress. Avaliamos o contexto do projeto e escolhemos a solução que faça sentido para o negócio.',
          },
        ],
      },
      ux: {
        overview:
          'Modernização da interface do site com foco em usabilidade, acessibilidade e experiência do usuário. Inclui melhoria da navegação, organização dos conteúdos, responsividade, hierarquia visual, padronização dos elementos e criação de interfaces mais intuitivas, agradáveis e alinhadas à identidade da marca.',
        outcomes: [
          'Páginas mais claras, organizadas e fáceis de escanear.',
          'Botões, formulários e jornadas com menos fricção para o usuário.',
          'Melhor consistência visual entre desktop, tablet e mobile.',
          'Recomendações práticas para aumentar conversão e confiança.',
        ],
        when_to_use: [
          'Usuários abandonam páginas antes de concluir ações importantes.',
          'O layout parece antigo, confuso ou inconsistente.',
          'A navegação mobile não está confortável.',
          'Você quer melhorar conversão sem reconstruir todo o produto.',
        ],
        workflow: [
          'Análise da experiência atual, hierarquia, fluxos e pontos de fricção.',
          'Priorização de melhorias com foco em clareza e conversão.',
          'Prototipação ou aplicação dos ajustes de layout.',
          'Revisão responsiva e recomendações para próximos ciclos.',
        ],
        workflow_titles: [
          'Análise UX',
          'Priorização',
          'Prototipação',
          'Revisão',
        ],
        faq: [
          {
            question: 'Preciso refazer todo o site para melhorar UX?',
            answer:
              'Nem sempre. Muitas melhorias vêm de ajustes de hierarquia, espaçamento, navegação, botões, formulários e responsividade sem reconstruir tudo.',
          },
          {
            question: 'Vocês entregam protótipo ou já implementam?',
            answer:
              'Depende do escopo. Podemos entregar protótipos, recomendações visuais ou implementar os ajustes diretamente no produto.',
          },
          {
            question: 'UX ajuda em conversão?',
            answer:
              'Sim. Uma interface mais clara reduz fricção, aumenta confiança e facilita ações como contato, compra, cadastro ou pedido de orçamento.',
          },
          {
            question: 'É possível melhorar a experiência de leitura?',
            answer:
              'Sim. Podemos ajustar textos, tamanhos, espaçamentos e organização para tornar a leitura mais confortável.',
          },
          {
            question: 'Vocês podem melhorar formulários?',
            answer:
              'Sim. Podemos simplificar campos, melhorar instruções e tornar o preenchimento mais fácil.',
          },
          {
            question: 'O tema escuro funciona automaticamente?',
            answer:
              'Pode funcionar manualmente ou seguir a preferência configurada no dispositivo do usuário.',
          },
          {
            question: 'A otimização pode melhorar a experiência no celular?',
            answer:
              'Sim. Podemos revisar tamanhos, menus, botões e disposição dos conteúdos para telas menores.',
          },
          {
            question: 'É possível manter o estilo atual e apenas modernizá-lo?',
            answer:
              'Sim. Não é necessário criar uma identidade totalmente nova para melhorar o layout.',
          },
          {
            question: 'Os textos do site também podem ficar mais claros?',
            answer:
              'Sim. Podemos melhorar textos de navegação, títulos, chamadas e conteúdos para facilitar o entendimento.',
          },
          {
            question: 'A otimização muda a identidade da marca?',
            answer:
              'Não necessariamente. Podemos preservar cores, logotipo e características da marca enquanto modernizamos a interface.',
          },
          {
            question: 'É possível melhorar páginas muito carregadas?',
            answer:
              'Sim. Podemos reorganizar elementos e reduzir excesso de informação para deixar a experiência mais leve.',
          },
        ],
      },
      digital_link_page: {
        overview:
          'Criamos páginas de links digitais personalizadas que reúnem de forma clara links importantes, canais de redes sociais, dados de contato e ofertas em um só lugar.',
        outcomes: [
          'Página de links com identidade visual alinhada à marca.',
          'Links, redes sociais, contatos e ofertas organizados com clareza.',
          'Experiência rápida e responsiva para celular, tablet e desktop.',
          'Estrutura simples de manter e preparada para campanhas.',
        ],
        when_to_use: [
          'Você precisa de uma alternativa mais profissional para link na bio.',
          'Links importantes estão espalhados em muitos canais.',
          'Você quer destacar contatos, redes sociais, ofertas ou campanhas.',
          'Sua equipe precisa atualizar links com mais organização.',
        ],
        workflow: [
          'Mapeamos links, canais, ofertas e prioridades de comunicação.',
          'Definimos estrutura, hierarquia visual e identidade da página.',
          'Construímos uma página leve, responsiva e fácil de acessar.',
          'Publicamos e orientamos sua equipe sobre atualizações futuras.',
        ],
        workflow_titles: [
          'Mapeamento',
          'Estrutura',
          'Construção',
          'Publicação',
        ],
        faq: [
          {
            question: 'Isso substitui um site completo?',
            answer:
              'Não necessariamente. A página de links funciona como uma entrada rápida para canais, contatos e ofertas, mas pode complementar um site completo.',
          },
          {
            question: 'A página pode seguir a identidade da marca?',
            answer:
              'Sim. Podemos adaptar cores, tipografia, textos e organização para ficar alinhada à marca.',
          },
          {
            question: 'É possível medir cliques?',
            answer:
              'Sim. Podemos configurar mensuração para acompanhar cliques e entender quais links geram mais interação.',
          },
        ],
      },
      cyber: {
        overview:
          'O serviço de Cibersegurança identifica riscos práticos em sites e sistemas. A proposta é reforçar a proteção de forma objetiva, com medidas aplicáveis, prioridades claras e acompanhamento dos pontos mais críticos.',
        outcomes: [
          'Visão clara dos riscos técnicos e operacionais mais importantes.',
          'Melhor controle de acessos, autenticação, permissões e exposição de dados.',
          'Relatório com vulnerabilidades identificadas, prioridades de correção e recomendações de melhoria.',
          'Redução de vulnerabilidades comuns em sites, APIs, servidores e dependências.',
        ],
        when_to_use: [
          'Seu site ou sistema lida com dados sensíveis de clientes.',
          'Há muitos usuários, acessos internos ou permissões sem revisão.',
          'Você precisa se preparar para auditoria, crescimento ou integração externa.',
          'Atualizações, backups e monitoramento ainda não estão bem estruturados.',
        ],
        workflow: [
          'Levantamento dos ativos, acessos, integrações e superfícies de risco.',
          'Análise de configurações, dependências, permissões e práticas críticas.',
          'Plano de correção com severidade, esforço e impacto.',
          'Acompanhamento de melhorias e recomendações de monitoramento contínuo.',
        ],
        workflow_titles: [
          'Levantamento',
          'Análise',
          'Correção',
          'Monitoramento',
        ],
        faq: [
          {
            question: 'O serviço inclui teste de invasão?',
            answer:
              'O escopo padrão foca em avaliação prática, hardening e redução de riscos. Testes ofensivos mais profundos podem ser definidos separadamente conforme necessidade e autorização.',
          },
          {
            question: 'Vocês corrigem os problemas encontrados?',
            answer:
              'Podemos corrigir diretamente ou trabalhar com o seu time, priorizando vulnerabilidades por severidade, exposição e esforço de implementação.',
          },
          {
            question: 'Esse serviço é só para empresas grandes?',
            answer:
              'Não. Pequenas e médias empresas também precisam proteger acessos, dados, backups, dependências e sites, especialmente quando dependem de canais digitais.',
          },
        ],
      },
      audit: {
        overview:
          'A Auditoria reúne uma visão rápida e estruturada sobre privacidade, performance, SEO, acessibilidade, usabilidade e segurança. É indicada para entender onde estão os principais problemas antes de iniciar um projeto maior ou priorizar melhorias.',
        outcomes: [
          'Diagnóstico objetivo dos principais pontos fortes e fracos do site.',
          'Lista priorizada de melhorias com explicação do impacto esperado.',
          'Evidências técnicas para apoiar decisões de investimento.',
          'Recomendações acionáveis para próximos passos de curto e médio prazo.',
        ],
        when_to_use: [
          'Você quer saber por onde começar antes de contratar desenvolvimento.',
          'O site existe, mas os resultados comerciais ou técnicos não estão claros.',
          'Há dúvidas sobre privacidade, SEO, acessibilidade ou segurança.',
          'Você precisa apresentar prioridades para stakeholders ou diretoria.',
        ],
        workflow: [
          'Coleta de contexto, objetivos e URLs ou sistemas que serão avaliados.',
          'Análise técnica com ferramentas, revisão manual e critérios de negócio.',
          'Organização dos achados por severidade, impacto e facilidade de correção.',
          'Entrega do relatório com recomendações claras e conversa de alinhamento.',
        ],
        workflow_titles: ['Contexto', 'Análise', 'Priorização', 'Relatório'],
        faq: [
          {
            question: 'A auditoria é indicada antes de um projeto maior?',
            answer:
              'Sim. Ela ajuda a entender prioridades reais antes de investir em redesign, desenvolvimento, SEO, segurança ou melhorias de performance.',
          },
          {
            question: 'O relatório é técnico demais?',
            answer:
              'Não. Organizamos os achados com explicação clara, impacto no negócio e próximos passos, mantendo detalhes técnicos quando eles ajudam na implementação.',
          },
          {
            question: 'Depois da auditoria vocês podem executar as melhorias?',
            answer:
              'Sim. A auditoria pode virar um plano de execução com priorização, orçamento e acompanhamento das correções.',
          },
        ],
      },
    },

    features: {
      ux_modern_layout: 'Layout moderno: visual mais atual e profissional.',
      ux_better_navigation:
        'Navegação melhorada: acesso mais fácil às informações.',
      ux_usability: 'Mais usabilidade: experiência simples e prática.',
      ux_accessibility: 'Acessibilidade: melhor leitura e interação.',
      ux_responsive_design:
        'Design responsivo: adaptação para todos os dispositivos.',
      ux_intuitive_interface:
        'Interface intuitiva: ações e informações mais claras.',
      ux_light_dark_theme:
        'Tema claro e escuro: mais conforto e personalização.',

      link_page_links: 'Links importantes organizados em um só lugar',
      link_page_socials: 'Canais de redes sociais destacados com clareza',
      link_page_contact: 'Dados de contato acessíveis e fáceis de usar',
      link_page_offers: 'Ofertas, campanhas ou chamadas em destaque',
      link_page_responsive: 'Página rápida, responsiva e personalizada',

      up_to_pages: 'Até {{count}} páginas',
      unlimited_pages: 'Páginas ilimitadas',
      text_images_tables: 'Textos, imagens e tabelas',
      nav_footer: 'Navegação e footer',
      cookie_banner: 'Banner de consentimento de cookies',
      professional_email: 'E-mail profissional',
      third_party_api: 'Integração de APIs de terceiros',
      cms_database: 'CMS / Banco de dados',
      ecommerce: 'E-commerce',
      previous_features: 'Todas as funcionalidades dos planos anteriores',
      full_ecommerce: 'Configuração completa de e-commerce',
      on_demand: 'Funcionalidades sob demanda',

      deliverable_seo_audit:
        'Análise de SEO técnico com plano de ação claro para aumentar visibilidade',
      deliverable_cw_vitals:
        'Otimização de velocidade e experiência do usuário',
      deliverable_accessibility: 'Garantia de acessibilidade',
      deliverable_indexing: 'Melhoria de encontrabilidade e indexação',
      delivery_weekly_report:
        'Relatório mensal de desempenho e próximos passos',

      ga4_setup: 'Configuração de Google Analytics 4',
      gtm_events: 'Eventos, conversões e Google Tag Manager',
      google_shopping_events: 'Eventos de Google Shopping como opção',
      schema_markup: 'Schema markup para páginas, produtos e serviços',
      analytics_validation: 'Validação técnica de dados e rastreamento',

      pim_integration:
        'Integração do PIM com E-commerce / ERP (Oracle, Abacus, Bling)',
      pim_data_model: 'Modelo de dados e estratégia de atributos',
      pim_import_export: 'Pipelines de importação/exportação e automação',
      pim_quality_rules: 'Regras de qualidade e validação de dados',

      delivery_hand_over:
        'Documentação clara e treinamento para que seu time tenha autonomia',

      ecommerce_store_setup: 'Criação ou reconstrução de loja online',
      ecommerce_catalog_checkout: 'Catálogo, produto e checkout estruturados',
      ecommerce_integrations:
        'Integrações com pagamento, logística, ERP ou PIM',
      ecommerce_performance_tracking:
        'Performance, SEO e mensuração preparados para crescer',

      wp_build_or_rebuild: 'Criação e reconstrução',
      wp_performance: 'Performance e velocidade',
      wp_security_hardening: 'Segurança e estabilidade',
      wp_plugins_quality: 'Plugins, tema e arquitetura',
      delivery_monthly_maintenance: 'Manutenção contínua',
      wp_technical_seo: 'SEO técnico',

      cyber_risk_assessment: 'Avaliação de riscos e análise de ameaças',
      cyber_website_security: 'Análise de segurança em websites',
      cyber_api_security: 'Segurança de APIs',
      cyber_code_security: 'Análise de segurança em código',
      cyber_monitoring: 'Monitoramento e alertas para riscos críticos',
      delivery_security_report:
        'Relatório de segurança com prioridades e cronograma',
    },

    cta_get_started: 'Começar agora',
    cta_request_proposal: 'Solicitar proposta',
    whatsapp_message:
      'Olá! Quero contratar o serviço "{{service}}" pelo valor de {{price}}, conforme mostrado no site.',
    long_term_note:
      'Condições especiais disponíveis para projetos e contratos de longo prazo.',
    long_term_cta: 'Discuta seu projeto agora!',
    long_term_whatsapp_message:
      'Olá! Quero discutir um projeto e conhecer as condições especiais disponíveis para projetos e contratos de longo prazo.',
    price_on_request: 'valor sob consulta',
    commercial_table_title: 'Condições comerciais',
    commercial_table: {
      billing: 'Faturamento',
      hourly_rate: 'Taxa horária',
      commitment: 'Compromisso',
      rows: {
        row_0: {
          billing: '0',
          hourly_rate: '50 CHF',
          commitment: 'Sem compromisso',
        },
        row_1: {
          billing: "15'000",
          hourly_rate: '45 CHF',
          commitment: '4 dias por mês. Duração mínima de 3 meses.',
        },
        row_2: {
          billing: "30'000",
          hourly_rate: '40 CHF',
          commitment: '8 dias por mês. Duração mínima de 3 meses.',
        },
        row_3: {
          billing: "45'000",
          hourly_rate: '35 CHF',
          commitment: '14 dias por mês. Duração mínima de 6 meses.',
        },
        row_4: {
          billing: "60'000",
          hourly_rate: '30 CHF',
          commitment: '21 dias por mês. Duração mínima de 6 meses.',
        },
      },
    },

    extras_title: 'Extras & Manutenção',

    extras: {
      cookie_banner: {
        title: 'Banner de Cookies',
        desc: 'Mantenha conformidade com privacidade e aumente a confiança de quem visita seu site.',
      },

      professional_email: {
        title: 'E-mail Profissional',
        desc: 'Configuração de e-mail com sua marca para uma presença mais profissional.',
      },

      audits: {
        title: 'Auditorias',
        desc: 'Auditoria completa de privacidade, performance (SEO) e impacto ambiental (pegada de CO2).',
      },

      maintenance: {
        title: 'Manutenção',
        desc: 'Mantenha seu site seguro e atualizado.',
        tier_individual: '(Individual)',
        tier_business: '(Business)',
        tier_custom: '(Sob medida)',
      },
    },

    faq_title_prefix: 'Perguntas',
    faq_title_accent: 'frequentes',

    faq: {
      q1: 'O que é um PIM e para que ele serve?',
      a1: 'Um PIM (Product Information Management) é um sistema que centraliza, organiza, valida e distribui informações de produto para todos os canais de venda e comunicação — como e-commerce, ERP, marketplaces, catálogos e APIs. Assim, os dados ficam consistentes, a qualidade aumenta e os produtos podem ser publicados mais rápido.',
      q2: 'Meu time consegue usar o PIM facilmente?',
      a2: 'Sim. O PIM é configurado para que times de produto, marketing e tecnologia consigam usar bem no dia a dia. O projeto também inclui documentação clara, treinamento e boas práticas de governança — para que o time trabalhe com autonomia e eficiência.',
      q3: 'Que melhorias concretas de Layout & UX vocês fazem na prática?',
      a3: 'A gente melhora Layout & UX de um jeito bem prático: deixamos o site realmente responsivo (mobile, tablet e desktop funcionam certinho), organizamos a hierarquia e refinamos espaçamentos, tipografia e contraste para o layout ficar mais limpo, bonito e profissional. Também otimizamos navegação e botões para a experiência ficar mais intuitiva e fluida — menos fricção, mais clareza — incluindo melhorias de acessibilidade para funcionar bem para todo mundo.',
      q4: 'O que é SEO e por que é importante para o meu site?',
      a4: 'SEO (Search Engine Optimization) são práticas que aumentam a visibilidade do seu site em buscadores (como o Google). Um bom SEO amplia alcance, traz tráfego qualificado e gera mais oportunidades de negócio de forma orgânica — sem depender só de anúncios.',
      q6: 'Que ações posso tomar para melhorar meu ranking no Google?',
      a6: 'Ações importantes incluem: otimizar títulos e descrições, usar palavras-chave relevantes, criar conteúdo de qualidade, deixar o site mais rápido, garantir uma ótima experiência no mobile e estruturar o site tecnicamente para facilitar o entendimento pelos buscadores.',
      q7: 'O que é cibersegurança e como ela protege meu site ou sistema?',
      a7: 'Cibersegurança reúne práticas, tecnologias e processos que protegem sistemas, redes e dados contra ataques digitais, acesso não autorizado e vazamentos — garantindo integridade, confidencialidade e disponibilidade.',
      q8: 'Quais são as medidas mais importantes para proteger meus dados e usuários?',
      a8: 'Entre as principais medidas estão: SSL, senhas fortes, autenticação em dois fatores, atualizações frequentes de sistemas e dependências, backups regulares, controle de acesso e monitoramento contínuo de possíveis ameaças.',
      q9: 'Quais resultados concretos uma auditoria pode trazer para minha empresa?',
      a9: 'A auditoria traz efeitos bem diretos no negócio: melhora velocidade e experiência (principalmente no mobile), reduz fricção na navegação e aumenta conversões (compra, cadastro, pedido de orçamento); fortalece SEO técnico para elevar tráfego orgânico; identifica e corrige gaps de privacidade e conformidade para reduzir risco e aumentar confiança; aponta vulnerabilidades com um checklist essencial de segurança; melhora acessibilidade e usabilidade; e recomenda otimizações que reduzem peso de página e consumo de recursos — diminuindo custos e impacto ambiental.',
      q10: 'O que são projetos em WordPress?',
      a10: 'Projetos em WordPress são trabalhos em que um site (ou parte dele) é criado, ajustado ou otimizado usando WordPress — uma plataforma para construir e gerenciar conteúdo. Na prática, inclui sites institucionais, blogs ou landing pages, lojas com WooCommerce, ajustes de layout e responsividade, configuração de plugins (SEO, performance, formulários, segurança), integrações (CRM, analytics, pagamentos) e manutenção/atualizações/correções para o site ficar mais rápido, seguro e com melhor experiência.',
    },
  },

  customers: {
    title: 'Nossos clientes',
  },

  marquee: {
    ariaLabel: 'Destaques',
    line1: 'DESENVOLVIMENTO SOB MEDIDA — INTEGRAÇÕES DE API — CMS — E-COMMERCE',
    line2:
      'SEO TÉCNICO — PERFORMANCE — ACESSIBILIDADE — WEB VITALS — AUDITORIAS',
  },

  pagenotfound: {
    tagline: 'Fora da trilha — siga o azul do lago de volta para casa.',
    backHome: 'Voltar para a página inicial',
    notFound: 'Página não encontrada',
  },

  welcome_message: 'Bem-vindo ao meu portfólio',

  instagramLinks: {
    ariaLabel: 'Links sociais da BlueAlps',
    shareLabel: 'Compartilhar',
    bio: [
      'Tecnologia suíça, talento brasileiro.',
      'Desenvolvemos soluções digitais inovadoras',
      'para empresas que querem crescer.',
    ],
    cards: {
      instagram: {
        title: 'Instagram',
        subtitle: 'Acompanhe novidades, projetos e bastidores.',
        cta: 'Ver perfil',
      },
      website: {
        title: 'BlueAlps',
        subtitle: 'Conheça nossas soluções digitais.',
        cta: 'Visitar site',
      },
      whatsapp: {
        title: 'WhatsApp',
        subtitle: 'Fale diretamente com a nossa equipe.',
        cta: 'Enviar mensagem',
      },
      booking: {
        title: 'Microsoft Bookings',
        subtitle: 'Agende uma reunião gratuita com a nossa equipe.',
        cta: 'Agendar',
      },
    },
    footer: [
      { label: 'Preferências de cookies', href: '/cookie-policy' },
      { label: 'Reportar', href: '/contact' },
      { label: 'Privacidade', href: '/privacy-policy' },
      { label: 'Sobre esta conta', href: '/imprint' },
      { label: 'Mais da BlueAlps', href: '/' },
    ],
  },

  footer: {
    extra_links: 'Links adicionais',
    home: 'Início',
    about: 'Sobre nós',
    services: 'Serviços',
    project: 'Projetos',
    impact: 'Impacto',
    contact_button: 'Contato',
    imprint: 'Impressum',
    privacy: 'Política de Privacidade',
    cookie: 'Política de Cookies',
  },

  home: {
    hero: {
      eyebrow: 'TI RESPONSÁVEL',
      title_line1: 'Software de alta qualidade,',
      title_line2: 'com custos reduzidos.',
    },

    cta_primary: 'Começar agora',
    caption: 'Desenvolvimento de software com qualidade e economia.',
    more_info: 'Saiba mais sobre nós',
    more_info_services: 'Conheça agora nossos serviços',

    services_teaser_title:
      'Encontre especialistas para acelerar sua transformação digital',
    services_teaser_subtitle:
      'Especialistas sob demanda em desenvolvimento de software, inteligência artificial, SEO, PIM, WordPress, cibersegurança e muito mais.',
    services_teaser_price_note:
      'Fale com a gente para encontrar o especialista ideal para o seu desafio.',
    services_teaser_cta: 'Descubra nossos serviços',
    services_teaser_custom_quote: 'Solicitar proposta sob medida',

    purposetitle_part1: 'Tecnologia que conecta',
    purposetitle_part2: 'inovação e impacto',

    purpose:
      'A BlueAlps é uma empresa suíço-brasileira especializada em desenvolvimento de software personalizado, inteligência artificial, automação e transformação digital para empresas.\nCombinamos a criatividade brasileira à precisão suíça para criar soluções tecnológicas escaláveis, seguras e de alta qualidade, ajudando organizações a inovar, otimizar processos e acelerar seu crescimento. Atuamos com foco em excelência técnica e impacto positivo, sempre guiados pelos valores de equidade, inclusão, integridade, colaboração e sustentabilidade.',
    purpose_values_label: 'Valores da BlueAlps',
    purpose_values: {
      equity: 'Equidade',
      inclusion: 'Inclusão',
      integrity: 'Integridade',
      collaboration: 'Colaboração',
      sustainability: 'Sustentabilidade',
    },
    company_cta: 'Saiba mais sobre nossa empresa',

    vision_title: 'Visão',
    vision_text:
      'Nossa visão é reduzir desigualdades sociais e promover um mundo mais justo, inclusivo, diverso e sustentável, conectando os pontos fortes de duas culturas complementares — Brasil e Suíça. Inspiramos e viabilizamos mudanças positivas por meio de engenharia comprometida com a sociedade, unindo inovação técnica e responsabilidade social.',

    mission_title: 'Missão',
    mission_text:
      'Nossa missão é apoiar pequenas e médias empresas com soluções de software acessíveis e performáticas, alinhadas aos Objetivos de Desenvolvimento Sustentável (ODS) da ONU. Unimos conhecimento técnico a formas de trabalho que promovem justiça, igualdade de oportunidades, diversidade e sustentabilidade. Além dos serviços, vivemos os valores que defendemos, criando um ambiente seguro, inclusivo e eticamente sólido para nosso time e nossos clientes.',

    core_values: 'Valores',
    core_values_text:
      'Os valores da organização são a base da sua identidade e guiam todas as decisões. Eles moldam a cultura e o impacto que geramos.',

    core_values_list_Equity: 'Equidade',
    core_values_list_Equity_text:
      'Oportunidades e resultados justos para todas as pessoas — com justiça em parcerias, processos e no ambiente de trabalho.',

    core_values_list_InclusionDiversity: 'Inclusão & Diversidade',
    core_values_list_InclusionDiversity_text:
      'Criar ambientes acolhedores que valorizem diferentes vozes, origens e experiências.',

    core_values_list_Integrity: 'Integridade',
    core_values_list_Integrity_text:
      'Atuar com transparência e ética em todas as interações — com clientes, colegas e a comunidade.',

    core_values_list_Sustainability: 'Sustentabilidade',
    core_values_list_Sustainability_text:
      'Tomar decisões que promovam saúde ambiental, social e econômica — hoje e no futuro.',

    core_values_list_Collaboration: 'Colaboração',
    core_values_list_Collaboration_text:
      'Crescer por meio de cooperação e parcerias fortes baseadas em respeito e objetivos comuns.',

    two_nations1: 'Ideias sem fronteiras:',
    two_nations2: 'unindo duas nações',

    switzerland: 'Suíça',
    brazil: 'Brasil',

    linkedin_link_label: 'Ver LinkedIn - Perfil de {{name}}',
    linkedin_link_text: 'Ver LinkedIn',

    our_mission: 'Nossa missão',
    our_mission_text:
      'Acreditamos que software deve ser uma ferramenta de transformação social. Na BlueAlps, não separamos excelência técnica de sustentabilidade.',

    our_essence: 'Nossa essência',
    our_essence_text:
      'Vivemos nossos valores. Agimos com responsabilidade. Lideramos com empatia. Porque um futuro sustentável não é uma ideia distante — é uma decisão coletiva que tomamos todos os dias.',

    our_commitment: 'Nosso compromisso',
    our_commitment_text:
      'Trabalhamos com propósito. Agimos com responsabilidade. Lideramos com empatia. Porque um futuro sustentável não é uma ideia distante — é uma decisão coletiva que tomamos todos os dias.',

    value_proposition: 'Proposta de valor',
    value_proposition_text:
      'Entregamos software moderno com alma, geramos resultados mensuráveis para o seu negócio e impacto positivo para a comunidade — eficiência com responsabilidade social.',

    develop_conscious1:
      'Desenvolvemos soluções digitais conscientes, sob medida para quem',
    develop_conscious2: 'acredita em tecnologia com impacto',

    develop_conscious_text:
      'Na BlueAlps, reduzimos desigualdades sociais por meio de engenharia inteligente e acessível. Inclusão, dignidade e colaboração guiam tudo o que fazemos — junto a parceiros que compartilham nossos valores.',

    commitment: 'Compromisso',
    commitment_text:
      'A BlueAlps é mais do que consultoria — é um compromisso com transformação significativa. Nosso trabalho é guiado por propósito, valores e parceria com quem acredita, como a gente, em um mundo mais equilibrado e sustentável.',

    software_development: 'Desenvolvimento de software',
    software_development_text:
      'Acreditamos que engenharia pode — e deve — ser uma ferramenta de transformação social. Na BlueAlps, não separamos excelência técnica de impacto humano. Unimos a precisão da engenharia suíça com a criatividade e resiliência da cultura brasileira para construir soluções eficientes e justas. Trabalhamos com propósito, agimos com responsabilidade e lideramos com empatia. Porque um futuro sustentável não é uma ideia distante — é uma decisão coletiva que fazemos diariamente em design, processos e relações.',

    ecommerce: 'E-commerce',
    ecommerce_text:
      'A BlueAlps apoia empresas com propósito por meio de soluções de engenharia de alto nível, acessíveis e orientadas a impacto, alinhadas a metas globais de sustentabilidade. Conectamos precisão técnica, práticas inclusivas e entendimento profundo de negócio para criar plataformas de e-commerce que impulsionam crescimento e mudança social.',

    team_text1:
      'Unimos talentos globais para desenvolver software de alta performance',
    team_text2: 'e gerar mais valor para o seu negócio',

    customers: 'Quem Confia na Blue Alps',
    customers_title_prefix: 'Quem',
    customers_title_accent: 'Confia',
    customers_title_suffix: 'na Blue Alps',
  },

  projects: {
    title: 'Projetos com impacto',
    subtitle:
      'Soluções inovadoras que constroem um futuro mais eficiente e sustentável.',
    view_details: 'Ver detalhes',

    items: [
      {
        id: 'divina',
        category: 'E-commerce',
        title: 'Divina E-Commerce',
        description:
          'Uma plataforma de e-commerce suíça para cama, banho e mesa. Um site multilíngue e responsivo com foco em usabilidade, variações de produto, checkout personalizado e integrações com sistemas locais.',
      },

      {
        id: 'farol',
        category: 'SEO',
        title: 'Farol SEO',
        description:
          'Uma plataforma automatizada de auditoria de SEO que analisa sites completos e entrega relatórios claros e acionáveis sobre SEO, performance e acessibilidade — ideal para fortalecer sua presença digital.',
      },

      {
        id: 'gallery',
        category: 'Sistema Admin',
        title: 'Gallery',
        description:
          'A Galerie Gleis 4 desenvolveu um app de comunicação para envio de e-mails em massa para clientes. Uma lista de convidados a partir de uma planilha permite campanhas de convite rápidas e eficientes.',
      },

      {
        id: 'muller',
        category: 'WordPress',
        title: 'Projeto Müller',
        description:
          'Migração de um CMS proprietário sem manutenção há mais de 10 anos para WordPress, com atualização tecnológica, adequação às exigências legais suíças, painel administrativo familiar, conteúdo estruturado e manual em PDF integrado. Feedback da cliente: Apreciei que, no momento de colocar o site no ar, vocês responderam muito rapidamente às dúvidas, mesmo depois que a página já estava online.',
      },

      {
        id: '1001',
        category: 'Manutenção',
        title: 'Projeto 1001',
        description:
          'Projeto de estágio avançado focado em manutenção corretiva e evolutiva, incluindo a atualização da integração com MongoDB para substituir uma versão obsoleta e garantir mais compatibilidade, segurança e continuidade operacional.',
      },

      {
        id: 'HausHeld',
        category: 'SEO e IA',
        title: 'HausHeld',
        description:
          'Otimização da presença digital com estratégias de SEO para melhorar desempenho, visibilidade em buscadores e tráfego orgânico, além de uma solução com Inteligência Artificial para tornar a navegação mais eficiente e intuitiva.',
      },
    ],
  },

  contact: {
    title: 'Contato',
    subtitle: 'Fale com a BlueAlps direto pelo WhatsApp.',
    direct_contact_note: 'Entre em contato conosco!',
    cta: 'Conversar',
    cta_email: 'Enviar e-mail',
    cta_booking: 'Agendar',
    whatsapp_label: 'WhatsApp BlueAlps',
    email_label: 'E-mail BlueAlps',
    booking_label: 'Agendar reunião',
    booking_hint: 'Escolha um horário pelo Microsoft Bookings sem custo',
    roles: {
      support: 'Atendimento',
      commercial: 'Vendas',
    },
    messages: {
      general: 'Olá! Gostaria de falar com a BlueAlps.',
      emanuele: 'Olá! Gostaria de falar com a Emanuele.',
      commercial: 'Olá! Gostaria de falar com o time comercial.',
    },
  },

  responsibleEntity: {
    title: 'Responsável',
    address:
      'Hefti Engineering GmbH\nPestalozzistrasse 11\n9400 Rorschach\nSuíça',
    email: 'E-mail:',
  },

  authorizedPersons: {
    title: 'Pessoas autorizadas a representar',
    name: 'Daniel Hefti',
  },

  company: {
    title: 'Nome da empresa',
    name: 'Hefti Engineering GmbH',
  },

  registration: {
    title: 'Número de registro',
    number: 'CHE-309.856.701',
  },

  disclaimer: {
    title: 'Aviso legal',
    p1: 'O autor não se responsabiliza pela exatidão, precisão e completude do conteúdo.',
    p2: 'Todas as ofertas são sem compromisso. Alterações reservadas.',
  },

  linksDisclaimer: {
    title: 'Aviso sobre links externos',
    p1: 'Não assumimos responsabilidade por conteúdos de sites externos.',
  },

  copyright: {
    title: 'Direitos autorais',
    p1: 'Todo o conteúdo deste site está protegido por direitos autorais da Hefti Engineering GmbH.',
  },

  source: 'Fonte: BrainBox Solutions',
};
